//TODO: Musi poczekać, bo jest zależne od innych modułów w tej libce
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from "@skylab-shared/core";

type ProductGetIdsByExternalIdsResponse = {
	items: {
		id: number;
		externalId: string;
	}[],
	totalItemsCount: number;
};


export type ProductGetIdsByExternalIdsResult = {
	id: number;
	externalId: string;
}[];

export class ProductGetIdsByExternalIdsQuery extends Query<ProductGetIdsByExternalIdsResult> {
	public constructor(public readonly params: {externalIds: string[]}) {
		super()
	}
}

export class ProductGetIdsByExternalIdsQueryHandlerBase implements QueryHandler<ProductGetIdsByExternalIdsQuery, ProductGetIdsByExternalIdsResult> {
	private static Url = TaggedUrl.join('products/ids-by-external-ids', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(query: ProductGetIdsByExternalIdsQuery): Promise<ProductGetIdsByExternalIdsResult> {
		const result = await this.http.get<ProductGetIdsByExternalIdsResponse>(ProductGetIdsByExternalIdsQueryHandlerBase.Url, {
			params: {
				externalIds: query.params.externalIds
			},
		});

		return result.data.items;
	}
}
